import { observer } from 'mobx-react';
import { ProductCollectionResource } from '../../../../Types';
import LearningCollectionEditStore from '../../../Edit/Store';
import { browseAllContext } from '../../../Types';
import ExperienceRowItems from '../Experiences/CustomizeRow/ExperienceRowItems';

interface Props {
  learningCollectionStore: LearningCollectionEditStore;
  resource: ProductCollectionResource;
}

function ExperienceRows({ learningCollectionStore, resource }: Props) {
  return resource.payload.experiences.map((experience) => (
    <tr key={experience.payload.id}>
      <ExperienceRowItems
        context={browseAllContext()}
        experienceResource={experience}
        store={learningCollectionStore}
        showLockIcon="show"
      />
    </tr>
  ));
}

export default observer(ExperienceRows);
